'use client';

import React from 'react';
import Select, { MultiValue } from 'react-select';
import styles from './FieldSelect.module.scss';
import { Control, Controller, UseFormRegister } from 'react-hook-form';
import { FieldProperties, FieldValidation } from '@/services/formSchema.service';
import { SchemaOptions } from '@sinclair/typebox';
import classNames from 'classnames';

interface IFieldSelect {
    control: Control;
    register: UseFormRegister<any>;
    validation: FieldValidation;
    fieldProperties: FieldProperties;
    fieldName: string;
}

export const FieldSelect: React.FC<IFieldSelect> = ({ control, fieldName, register, validation, fieldProperties }) => {
    const options = fieldProperties?.additionalFieldProperties.options || [];

    const { isRequired } = validation;

    const handleOnChange = (onChange: (...event: any[]) => void) => (val: MultiValue<SchemaOptions>) =>
        onChange(val.map((option) => option.value));

    const handleValue = (value: any) => options.find((options) => options.value === value);

    return (
        <div className={styles.select}>
            <Controller
                control={control}
                name={fieldName}
                render={({ field: { onChange, value } }) => (
                    <Select
                        {...register(fieldName, {
                            required: { value: isRequired.value, message: isRequired.message },
                        })}
                        classNames={{
                            control: () => styles.selectControl,
                            indicatorsContainer: () => styles.selectIndicatorsContainer,
                            option: ({ isFocused, isSelected }: { isFocused: boolean; isSelected: boolean }) =>
                                classNames(
                                    isFocused && styles.selectOptionsFocused,
                                    !isFocused && !isSelected && styles.selectOptions
                                ),
                            valueContainer: () => styles.selectValueContainer,
                            multiValue: () => styles.selectMultiValue,
                            multiValueRemove: () => styles.selectMultiValueRemove,
                            menuList: () => styles.selectMenuList,
                            menu: () => styles.selectListBox,
                        }}
                        isClearable={false}
                        isOptionDisabled={(option: SchemaOptions, selectValue: readonly SchemaOptions[]) =>
                            selectValue.length > 9
                        }
                        classNamePrefix={styles.select}
                        placeholder={fieldProperties.placeholder}
                        options={options}
                        value={handleValue(value)}
                        onChange={handleOnChange(onChange)}
                        isMulti={true}
                    />
                )}
            />
        </div>
    );
};
